export const Props = () => ({
  //ID Подкаста
  idPodcast: {
    type: Number,
    required: true,
  },
});